import { render, staticRenderFns } from "./historyElement.vue?vue&type=template&id=385bdf12&scoped=true&"
import script from "./historyElement.vue?vue&type=script&lang=js&"
export * from "./historyElement.vue?vue&type=script&lang=js&"
import style0 from "./historyElement.vue?vue&type=style&index=0&id=385bdf12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385bdf12",
  null
  
)

export default component.exports